"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const AuthContext_1 = require("../Auth/AuthContext");
const AuthLayout_1 = __importDefault(require("../Pages/Layout/AuthLayout"));
const DefaultLayout_1 = __importDefault(require("../Pages/Layout/DefaultLayout"));
const RouteWrapper = ({ component, isPrivate = false, ...rest }) => {
    const Component = component;
    const { isAuthenticated } = (0, AuthContext_1.useAuth)();
    /**
     * Redirect user to SignIn page if he tries to access a private route
     * without authentication.
     */
    if (isPrivate && !isAuthenticated) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: "/login" });
    }
    /**
     * Redirect user to Main page if he tries to access a non private route
     * (SignIn or SignUp) after being authenticated.
     */
    if (!isPrivate && isAuthenticated) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: "/" });
    }
    const Layout = !isAuthenticated ? AuthLayout_1.default : DefaultLayout_1.default;
    return (react_1.default.createElement(react_router_dom_1.Route, { ...rest, render: props => (react_1.default.createElement(Layout, null,
            react_1.default.createElement(Component, { ...props }))) }));
};
exports.default = RouteWrapper;
